<div class="container-fluid">
  <ul class="simple-list sideways-list stack-mobile" style="margin-top: 0">
    <li class="wl-give-calendar-right-padding">
      <label for="recurringSearchDateDateAndTimeToSendAfter" class="light-text wl-calendar-label">
        {{ 'communications.message-label.send-date-after' | translate | titlecase }}
      </label>
      <wl-date-selector
        name="recurringSearchDateDateAndTimeToSendAfter"
        [(ngModel)]="searchParams.DateAndTimeToSendAfter"
      ></wl-date-selector>
    </li>
    <li class="wl-give-calendar-right-padding">
      <label for="recurringSearchDateAndTimeToSendBefore" class="light-text wl-calendar-label">
        {{ 'communications.message-label.send-date-before' | translate | titlecase }}
      </label>
      <wl-date-selector name="recurringSearchDateAndTimeToSendBefore" [(ngModel)]="searchParams.DateAndTimeToSendBefore"></wl-date-selector>
    </li>
    <li>
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-primary tall"
        [disabled]="isSearching || isBusy"
        (click)="startSearch()"
        [icon]="!isSearching ? 'pi pi-search' : ''"
        [label]="isSearching ? ('common.searching' | translate | titlecase) : ('common.search' | translate | titlecase)"
      >
        <wl-busy [show]="isSearching"></wl-busy>
      </button>
    </li>
    <li>
      <button pButton type="button" class="atlas-btn atlas-btn-default tall" [routerLink]="['/communications/message/draft', 0]">
        <span class="pi pi-plus" style="margin-right: 4px"></span>
        {{ 'common.new' | translate | titlecase }}
      </button>
    </li>
  </ul>
  <p-table [showGridlines]="true"
    #recurringGrid
    [rows]="20"
    styleClass="wl-responsive-prime-datatable"
    [value]="recurringResult.Result"
    [paginator]="true"
    (onLazyLoad)="lazyLoadRecurringMessages($event)"
    [totalRecords]="recurringResult.TotalCount"
    [lazy]="true"
    [loading]="isSearching"
  >
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <p-button
        icon="pi pi-sort-alt"
        [rounded]="true"
        [text]="true"
        *ngIf="sortOrder === 0"
        aria-hidden="true"
        styleClass="wl-prime-datatable-column-advanced-sort-btn"
      />
      <p-button
        icon="pi pi-sort-amount-up-alt"
        [rounded]="true"
        [text]="true"
        *ngIf="sortOrder === 1"
        aria-hidden="true"
        styleClass="wl-prime-datatable-column-advanced-sort-btn"
      />
      <p-button
        icon="pi pi-sort-amount-down"
        [rounded]="true"
        [text]="true"
        *ngIf="sortOrder === -1"
        aria-hidden="true"
        styleClass="wl-prime-datatable-column-advanced-sort-btn"
      />
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th [pSortableColumn]="'Subject'" class="wl-prime-datatable-column-advanced-filter">
          <p>
            {{ 'communications.message-label.subject' | translate | titlecase }}
            <span *ngIf="searchParams.Subject" style="color: red">*</span>
          </p>
          <div class="wl-prime-datatable-column-advanced-filter-buttons">
            <p-sortIcon field="Subject" />
            <p-columnFilter
              type="text"
              field="Subject"
              display="menu"
              [showMatchModes]="true"
              [matchModeOptions]="[{ label: 'Subject has', value: 'contains' }]"
              [matchMode]="'contains'"
              [showOperator]="false"
              [showAddButton]="false"
              [showApplyButton]="true"
              [showClearButton]="false"
            >
              <ng-template pTemplate="filter" let-filter="filterCallback">
                <input type="text" pInputText [(ngModel)]="searchParams.Subject" (change)="filter($event.value)" />
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        <th [pSortableColumn]="'UpcomingSendDate'" class="wl-prime-datatable-column-advanced-filter wl-prime-datatable-hidden-phone">
          <p>
            {{ 'communications.message-label.send-date' | translate | titlecase }}
            <span *ngIf="searchParams.UpcomingSendDate" style="color: red">*</span>
          </p>
          <div class="wl-prime-datatable-column-advanced-filter-buttons">
            <p-sortIcon field="UpcomingSendDate" />
            <p-columnFilter
              field="SendDate"
              display="menu"
              [showMatchModes]="true"
              [matchModeOptions]="[{ label: 'Next send date on', value: 'dateIs' }]"
              [matchMode]="'dateIs'"
              [showOperator]="false"
              [showAddButton]="false"
              [showApplyButton]="true"
              [showClearButton]="false"
            >
              <ng-template pTemplate="filter" let-filter="filterCallback">
                <p-datepicker
                  [placeholder]="'communications.message-label.filter-by-next-send-date' | translate | ucfirst"
                  [(ngModel)]="searchParams.UpcomingSendDate"
                  [showButtonBar]="true"
                  (change)="filter($event.value)"
                ></p-datepicker>
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        <th
          [pSortableColumn]="'DateCreated'"
          class="wl-prime-datatable-column-advanced-filter wl-prime-datatable-hidden-tablet-and-smaller"
        >
          <p>
            {{ 'communications.message-label.date-created' | translate | titlecase }}
            <span *ngIf="searchParams.DateCreated" style="color: red">*</span>
          </p>
          <div class="wl-prime-datatable-column-advanced-filter-buttons">
            <p-sortIcon field="DateCreated" />
            <p-columnFilter
              field="DateCreated"
              display="menu"
              [showMatchModes]="true"
              [matchModeOptions]="[{ label: 'Created on', value: 'dateIs' }]"
              [matchMode]="'dateIs'"
              [showOperator]="false"
              [showAddButton]="false"
              [showApplyButton]="true"
              [showClearButton]="false"
            >
              <ng-template pTemplate="filter" let-filter="filterCallback">
                <p-datepicker
                  [placeholder]="'communications.message-label.filter-by-date-created' | translate | ucfirst"
                  [(ngModel)]="searchParams.DateCreated"
                  [showButtonBar]="true"
                  (change)="filter($event.value)"
                ></p-datepicker>
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        <th class="wl-prime-datatable-column-advanced-filter wl-prime-datatable-hidden-phone">
          <p>
            {{ 'communications.message-label.send-from' | translate | titlecase }}
            <span *ngIf="searchParams.SendFrom" style="color: red">*</span>
          </p>
          <div class="wl-prime-datatable-column-advanced-filter-buttons">
            <p-columnFilter
              type="text"
              field="SendFrom"
              display="menu"
              [showMatchModes]="true"
              [matchModeOptions]="[{ label: 'Sender has', value: 'contains' }]"
              [matchMode]="'contains'"
              [showOperator]="false"
              [showAddButton]="false"
              [showApplyButton]="true"
              [showClearButton]="false"
            >
              <ng-template pTemplate="filter" let-filter="filterCallback">
                <input type="text" pInputText [(ngModel)]="searchParams.SendFrom" (change)="filter($event.value)" />
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        <th class="wl-prime-datatable-column-advanced-filter wl-prime-datatable-hidden-phone">
          <p>
            {{ 'communications.message-label.recurrence' | translate | titlecase }}
            <span *ngIf="searchParams.CronSummary" style="color: red">*</span>
          </p>
          <div class="wl-prime-datatable-column-advanced-filter-buttons">
            <p-columnFilter
              type="text"
              field="CronSummary"
              display="menu"
              [showMatchModes]="true"
              [matchModeOptions]="[{ label: 'Recurrence has', value: 'contains' }]"
              [matchMode]="'contains'"
              [showOperator]="false"
              [showAddButton]="false"
              [showApplyButton]="true"
              [showClearButton]="false"
            >
              <ng-template pTemplate="filter" let-filter="filterCallback">
                <input type="text" pInputText [(ngModel)]="searchParams.CronSummary" (change)="filter($event.value)" />
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        <th [hidden]="true" class="wl-prime-datatable-column-advanced-filter wl-prime-datatable-hidden-tablet-and-smaller">
          <p>
            {{ 'communications.message-label.count' | translate | titlecase }}
            <span *ngIf="searchParams.Count" style="color: red">*</span>
          </p>
          <div class="wl-prime-datatable-column-advanced-filter-buttons">
            <p-columnFilter
              type="numeric"
              field="Count"
              display="menu"
              [showMatchModes]="true"
              [matchModeOptions]="[{ label: 'Count is', value: 'equal' }]"
              [matchMode]="'equal'"
              [showOperator]="false"
              [showAddButton]="false"
              [showApplyButton]="true"
              [showClearButton]="false"
            >
              <ng-template pTemplate="filter" let-filter="filterCallback">
                <p-inputNumber [(ngModel)]="searchParams.Count" (change)="filter($event.value)" />
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        <th class="wl-prime-datatable-column-advanced-filter wl-prime-datatable-hidden-phone">
          <p>
            {{ 'communications.message-label.end-date' | translate | titlecase }}
            <span *ngIf="searchParams.EndDate" style="color: red">*</span>
          </p>
          <div class="wl-prime-datatable-column-advanced-filter-buttons">
            <p-columnFilter
              field="EndDate"
              display="menu"
              [showMatchModes]="true"
              [matchModeOptions]="[{ label: 'End date on', value: 'dateIs' }]"
              [matchMode]="'dateIs'"
              [showOperator]="false"
              [showAddButton]="false"
              [showApplyButton]="true"
              [showClearButton]="false"
            >
              <ng-template pTemplate="filter" let-filter="filterCallback">
                <p-datepicker
                  [placeholder]="'communications.message-label.filter-by-end-date' | translate | ucfirst"
                  [(ngModel)]="searchParams.EndDate"
                  [showButtonBar]="true"
                  (change)="filter($event.value)"
                ></p-datepicker>
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        <th class="wl-prime-datatable-hidden-phone">
          <div class="wl-prime-datatable-column-advanced-filter"></div>
        </th>
      </tr>
    </ng-template>
    <ng-template let-message pTemplate="body">
      <tr>
        <td>
          <div style="overflow: hidden">
            <a [routerLink]="['/communications/message/draft', message.MessageId]">{{ message.Subject }}</a>
          </div>
          <div class="wl-prime-datatable-hidden-tablet-and-bigger">
            <p>
              <strong>{{ 'communications.message-label.next-send-date' | translate | titlecase }}: </strong>
              {{ message.UpcomingSendDate | date: 'shortDate' }} {{ message.UpcomingSendDate | date: 'shortTime' }}
              {{ localTimeZoneAbbreviation }}
            </p>
            <div>
              <strong>{{ 'communications.message-label.date-created' | translate | titlecase }}: </strong>
              {{ message.DateCreated | date: 'shortDate' }}
            </div>
            <p>
              <strong>{{ 'communications.message-label.send-from' | translate | titlecase }}: </strong> {{ message.SendFrom }}
            </p>
            <p [hidden]="true">
              <strong>{{ 'communications.message-label.count' | translate | titlecase }}: </strong>
              {{ message.CommunicationsCount }}
            </p>
            <p>
              <strong>{{ 'communications.message-label.recurrence' | translate | titlecase }}: </strong>
              {{ message.CronSummary }} {{ localTimeZoneAbbreviation }}
            </p>

            <button
              type="button"
              [disabled]="isSearching || isBusy"
              class="atlas-btn btn-sm atlas-btn-default"
              (click)="copyMessage(message)"
              title="{{ 'common.copy' | translate | titlecase }}"
            >
              <span class="pi pi-copy"></span>
            </button>
            <button
              type="button"
              [disabled]="isSearching || isBusy"
              class="atlas-btn btn-sm atlas-btn-default"
              (click)="editMessage(message.MessageId)"
              title="{{ 'common.edit' | translate | titlecase }}"
            >
              <span class="pi pi-pencil"></span>
            </button>
            <button
              type="button"
              [disabled]="isSearching || isBusy"
              class="atlas-btn btn-sm atlas-btn-danger"
              (click)="confirmDeleteMessage(message)"
              title="{{ 'common.delete' | translate | titlecase }}"
            >
              <span class="pi pi-trash"></span>
            </button>
          </div>
        </td>
        <td class="wl-prime-datatable-hidden-phone">{{ message.UpcomingSendDate | date: 'shortDate' }}</td>
        <td class="wl-prime-datatable-hidden-tablet-and-smaller">{{ message.DateCreated | date: 'shortDate' }}</td>
        <td class="wl-prime-datatable-hidden-phone">
          <div class="mct-flex mct-col" style="overflow: hidden" [title]="message.SendFrom">
            <span>{{ message.SendFromInfo[0] }}</span>
            <span>{{ message.SendFromInfo[1] }}</span>
          </div>
        </td>
        <td class="wl-prime-datatable-hidden-phone">
          <div style="overflow: hidden" [title]="message.CronSummary">{{ message.CronSummary }} {{ localTimeZoneAbbreviation }}</div>
        </td>
        <td [hidden]="true" class="wl-prime-datatable-hidden-tablet-and-smaller">{{ message.CommunicationsCount }}</td>
        <td class="wl-prime-datatable-hidden-phone">{{ message.EndDate | date: 'shortDate' }}</td>
        <td class="wl-prime-datatable-hidden-phone">
          <div>
            <action-button [label]="'common.actions' | translate | titlecase" [items]="actionItems(message)"> </action-button>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="7" class="text-center">
          {{ 'communications.mass-comm-message-admin.no-recurring' | translate | titlecase }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog
  #deleteDraftMessageConfirmationModal
  modal="true"
  [(visible)]="showModal"
  [closable]="false"
  styleClass="atlas-dialog-s"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <p>{{ 'communications.mass-comm-message-admin.message-delete-confirmation-prompt' | translate }}</p>
  <ng-template pTemplate="footer">
    <wl-busy [show]="deleting"></wl-busy>
    <button
      pButton
      type="button"
      class="atlas-btn atlas-btn-danger"
      (click)="deleteMessgeConfirmed()"
      [disabled]="deleting"
      icon="pi pi-trash"
      [label]="deleting ? ('common.deleting' | translate | titlecase) : ('common.delete' | translate | titlecase)"
    ></button>
    <button
      pButton
      type="button"
      class="atlas-btn atlas-btn-secondary"
      (click)="this.showModal = false"
      [disabled]="deleting"
      icon="pi pi-ban"
      [label]="'common.cancel' | translate | titlecase"
    ></button>
  </ng-template>
</p-dialog>
